module.exports = __webpack_public_path__ + "img/bb_icon.8c3b0baa.png";